import * as React from 'react'
import {
  CountdownWithData,
  EventsCountdownWithData,
  CalendarButton,
  CtaBanner,
  DictionaryValue,
} from '../../../components'
import { Layout } from '../../layout'
import ThreeColumnImageText from '../../../components/threeColumnImageText/ThreeColumnImageText'
import NonEventConfig from '../../../models/nonEventConfig'
import signup from '../../../static/icons/signup.svg'
import { FeaturedBrandsPanel } from '../../brand/featured-brands'
import EventType from '../../../models/eventType'

type Props = {
    eventType: EventType | undefined
    nonEventConfig: NonEventConfig
}

class NonEventHome extends React.Component<Props> {
    render() {
        const { eventType, nonEventConfig } = this.props

        return (
            <Layout>
                <CountdownWithData/>
                <CtaBanner title='be-reminded.title' description='be-reminded.description' eventType={eventType}>
                    { nonEventConfig.nextEventCalendarCompanyId && nonEventConfig.nextEventCalendarEventId && (
                        <CalendarButton
                            eventId={nonEventConfig.nextEventCalendarEventId}
                            companyId={nonEventConfig.nextEventCalendarCompanyId}
                            eventType={eventType}
                        >
                            <DictionaryValue token='be-reminded.cta' />
                        </CalendarButton>
                    )}
                </CtaBanner>
                {nonEventConfig.membershipBenefits &&
                    <ThreeColumnImageText
                        threeColumnData={nonEventConfig.membershipBenefits}
                    />
                }
                {nonEventConfig.topRetailers &&
                    <FeaturedBrandsPanel
                        title='home.top-retailers'
                        location='nonEvent.topRetailers'
                        footer='home.top-retailers.footer'
                    />
                }
                {nonEventConfig.whatShoppersAreSaying &&
                    <ThreeColumnImageText
                        threeColumnData={nonEventConfig.whatShoppersAreSaying}
                    />
                }
                <CtaBanner
                    title='become-member.title'
                    description='become-member.description'
                    ctaText='become-member.cta'
                    ctaUrl='/account?join'
                    icon={signup}
                    className='cta-banner--become-member'
                    eventType={eventType}
                    standardSite={true}
                />
                <EventsCountdownWithData/>
            </Layout>
        )
    }
}

export default NonEventHome
